import React, {FC} from 'react';
import {Section} from 'templates/reports/query';

import DataTable from './DataTable';

type TableProps = {
	rmr: Section
}

export const Table: FC<TableProps> = ({rmr}) => {
	return (
		<div>
			<h2>Estimated RMR (Table)</h2>
			<div>
				<p>
					The equations we've selected are the most accurate found in the
					scientific literature and use your fat free mass measurements
					to minimize measurement bias and root mean squared error (RMSE).

					Please see the sources and methodologies for more details.
				</p>
			</div>
			<DataTable rmr={rmr} />
		</div>
	);
};
